import { Component } from '@angular/core';
import { IInvoice, IBilling } from '../../../interfaces/graph-types';
import { WatchOrganizationService } from '../../../services/watch-organization.service';
import { Observable, Subscription } from 'rxjs';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';

@Component({
  selector: 'organization-billing',
  template: require('./organization-billing.component.pug'),
  styles: [require('./organization-billing.component.css').toString()],
})
export class OrganizationBillingComponent {
  invoices$: Observable<IInvoice[]>;
  bsModalRef: BsModalRef;

  subBilling: Subscription = null;
  loadingBilling: boolean = false;
  billing: IBilling = null;
  subReason: Subscription = null;

  // -------------------------------------------------------------------
  constructor(private watchOrganizationService: WatchOrganizationService) {}

  orgId: string;

  // -------------------------------------------------------------------
  ngOnInit() {
    this.orgId = this.watchOrganizationService.organizationId().getValue();
  }

  // -------------------------------------------------------------------
  ngOnDestroy(): void {}
}
